// Components==============
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/Button/Button';
import ImagesUpload from 'components/UI/ImagesUpload/ImagesUpload';
import TrainingCollapseCard from 'components/UI/TrainingCollapseCard/TrainingCollapseCard';
import { AnimatePresence, motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React, { useRef } from 'react';
import { framerFade } from 'utilities/FramerAnimations';
import { getTrainingIsCompleted } from 'pages/Workspace/TrainingDetails/components/getTrainingIsCompleted';
import Content from './Content/Content';
import './LessonCard.module.scss';
// =========================

export default function LessonCard({
  lesson,
  index,
  subscriber,
  toggleDone,
  handleEvidenceUpload,
  handleEvidenceDelete,
  locked,
}: {
  lesson: LessonTrainingSessionEntity;
  index: number;
  subscriber?: TrainingSubscriptionEntity;
  toggleDone?: any;
  handleEvidenceUpload?: any;
  handleEvidenceDelete?: any;
  locked?: boolean;
}) {
  const translate = useTranslate();

  const userId = useRedux((state) => state.authentication?.user?.id);

  const attendance = subscriber?.attendances?.find(
    (a) => a.lesson_id === lesson.id
  );

  const completed = getTrainingIsCompleted(
    lesson,
    attendance,
    subscriber?.user_id
  );

  const attendanceId = attendance?.id;

  const labelRef = useRef<HTMLLabelElement>(null);

  const evidence =
    attendance?.evidence?.filter((e) => e.created_by === subscriber?.user_id) ||
    [];

  return (
    <div style={{ opacity: locked ? 0.5 : 1 }}>
      <TrainingCollapseCard
        lessonIndex={index + 1}
        left={
          <div styleName="title">
            <AnimatePresence>
              {completed && (
                <motion.div {...framerFade}>
                  <FontAwesomeIcon icon={faCheckCircle} />
                </motion.div>
              )}
            </AnimatePresence>
            <h3>{lesson?.title}</h3>
          </div>
        }
        locked={locked}
      >
        <div styleName="content">
          {!!lesson.description && <p>{lesson.description}</p>}
          {!!lesson.contents.length && (
            <div styleName="content">
              {lesson.contents
                .sort((a, b) => (a.order_index || 0) - (b.order_index || 0))
                .map((content, i) => (
                  <Content content={content} key={i} />
                ))}
            </div>
          )}
          {!!(!lesson.evidence_required && subscriber?.user_id === userId) && (
            <div styleName="centered-button">
              <Button
                color={completed ? 'green' : 'grey'}
                onClick={() =>
                  toggleDone({
                    done: completed,
                    lessonId: lesson.id!,
                    attendanceId,
                  })
                }
              >
                {translate('work.actions.work-done')}
                <AnimatePresence>
                  {completed && (
                    <motion.div {...framerFade}>
                      <FontAwesomeIcon icon={faCheck} />
                    </motion.div>
                  )}
                </AnimatePresence>
              </Button>
            </div>
          )}
          {!!lesson.evidence_required && (
            <>
              {evidence.length ? (
                <div>
                  <p styleName="my-work">
                    {translate('general.terms.my-work')}
                  </p>
                  <ImagesUpload
                    evidence={evidence}
                    lesson={lesson}
                    handleUpload={
                      subscriber?.user_id === userId
                        ? (e) => handleEvidenceUpload(e, lesson)
                        : undefined
                    }
                    handleDelete={(c) =>
                      handleEvidenceDelete({ evidenceId: c.evidenceId })
                    }
                  />
                </div>
              ) : subscriber?.user_id === userId ? (
                <>
                  <input
                    type="file"
                    id={`evidence-btn-${lesson.id}`}
                    onChange={(e) => handleEvidenceUpload(e, lesson)}
                    name="upload"
                    styleName="upload"
                  />
                  <div styleName="centered-button">
                    <label htmlFor={`evidence-btn-${lesson.id}`} ref={labelRef}>
                      <Button
                        color="grey"
                        onClick={() =>
                          labelRef.current
                            ? labelRef.current.click()
                            : undefined
                        }
                      >
                        {translate('work.actions.show-work')}
                      </Button>
                    </label>
                  </div>
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      </TrainingCollapseCard>
    </div>
  );
}
